<section *ngIf="data" class="simple-table">
	<ng-container *ngFor="let row of data.cells; index as rowIndex">
		<section
			*ngIf="(data?.headersY)[rowIndex]?.config?.visible"
			class="row text-14 align-items-center"
			[ngClass]="{
				striped: isStriped,
				'group-member': (data?.headersY)[rowIndex]?.attribute?.isGroupMember,
				'category-top-border': (data?.headersY)[rowIndex]?.attribute?.hasCategoryTopBorder
			}"
			[class.minimal]="data.headersX.length === 1"
		>
			<span class="col text-sm-14-bold" [ngClass]="categoryColumnClass" attr.data-cy="dl-simple-table-category-{{ data.firstColumnTitle.formattedValue }}-{{ rowIndex }}">
				<icon
					*ngIf="data.headersY[rowIndex].attribute && data.headersY[rowIndex].attribute.iconType && !colors"
					[style.fill]="data.headersY[rowIndex].attribute.colorTheme || DEFAULT_COLOR_THEME"
					class="pull-left category-icon"
					[type]="data.headersY[rowIndex].attribute.iconType"
				></icon>
				<icon
					*ngIf="(data?.headersY)[rowIndex]?.attribute?.iconType && colors"
					[style.fill]="colors[rowIndex]"
					class="pull-left category-icon"
					[type]="(data?.headersY)[rowIndex]?.attribute?.iconType"
				></icon>
				<span class="icon-caption" [ngClass]="{ 'sub-category text-sm-14': data.headersY[rowIndex].parent }">{{ data.headersY[rowIndex].formattedValue }}</span>
				<info-bubble
					*ngIf="(data?.headersY)[rowIndex]?.config?.infoBubble"
					[defaultValue]="data.headersY[rowIndex]?.attribute.infoBubble || data.headersY[rowIndex].config?.infoBubble"
					[customTracking]="'tooltip_' + data.headersY[rowIndex].formattedValue"
				></info-bubble>
				<dcr-cell-content [cell]="data.headersY[rowIndex]"></dcr-cell-content>
				<ng-container *ngFor="let cell of row">
					<p *ngIf="cell.config && cell.config.id === 'asOfDate' && cell.formattedValue" class="text-12 as-of-date">
						<span dcrHTMLKey="LABEL_AS_OF">As of</span> {{ cell.formattedValue }}
					</p>
				</ng-container>
			</span>

			<ng-container *ngFor="let cell of row; index as cellIndex">
				<ng-container *ngIf="cell.config && cell.config.visible">
					<span
						*ngIf="cell.formattedValue; else notApplicable"
						class="col text-align-right"
						[ngClass]="dataColumnClass"
						attr.data-cy="dl-simple-table-cell-{{ data.firstColumnTitle.formattedValue }}-{{ rowIndex }}-{{ cellIndex }}"
					>
						{{ cell.formattedValue }}
					</span>
				</ng-container>
			</ng-container>
		</section>
	</ng-container>
</section>

<ng-template #notApplicable> <span class="col text-align-right" [ngClass]="dataColumnClass">n/a</span> </ng-template>
